import React from "react";
import PropTypes from "prop-types";
import RSForm from "reactstrap/lib/Form";
import { Formik } from "formik";
import * as Yup from "yup"; // Importing as * because Yup doesn't provide default export. https://github.com/jquense/yup/issues/218

import { gatherClasses, isFunction } from "../../lib/utils";
import "./form.scss";

const Form = props => {
  const { onSubmit, withValidation, validate, dataTestId, ...attr } = props;

  if (withValidation) {
    return (
      <Formik
        isInitialValid={attr.isInitialValid}
        initialValues={attr.initialValues}
        enableReinitialize={attr.enableReinitialize}
        validationSchema={
          isFunction(attr.validationSchema) && attr.validationSchema(Yup)
        }
        validate={isFunction(validate) && validate}
        onSubmit={onSubmit}
      >
        {({ handleSubmit, ...formikProps }) => {
          return (
            <RSForm
              data-testid={dataTestId}
              className={gatherClasses(attr)}
              onSubmit={handleSubmit}
              inline={attr.inline}
              innerRef={attr.innerRef}
              noValidate={attr.noValidate}
            >
              {isFunction(attr.renderChildren) &&
                attr.renderChildren(formikProps)}
            </RSForm>
          );
        }}
      </Formik>
    );
  }
  return (
    <RSForm
      data-testid={dataTestId}
      className={gatherClasses(attr)}
      {...attr}
      onSubmit={onSubmit}
    >
      {attr.children}
    </RSForm>
  );
};

Form.propTypes = {
  children: PropTypes.node,
  inline: PropTypes.bool,
  noValidate: PropTypes.bool,
  innerRef: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func,
    PropTypes.string
  ]),
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  validate: PropTypes.func,
  withValidation: PropTypes.bool,
  onSubmit: PropTypes.func,
  enableReinitialize: PropTypes.bool
};

Form.defaultProps = {
  noValidate: true,
  inline: false,
  withValidation: false,
  onSubmit: () => {},
  dataTestId: "orion-form"
};

Form.displayName = "OrionForm";

export default Form;
